import React from "react";


import { connect } from "react-redux";
class CommonTitleHeader extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }


    render(){
    console.log('Inside render');
    return(
       
        <div class="dashhead">
        <h3>{this.props.headerTitle}</h3>
        </div>
        
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(CommonTitleHeader);
